import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import './Input.css';

export interface Props extends FlexProps {
  /** Applies styling to indicate the input is disabled */
  disabled?: boolean;
  /** Applies styling to indicate the input is invalid */
  invalid?: boolean;
  /** Applies styling to indicate the input is readOnly */
  readOnly?: boolean;
}

/**
 * The wrapping container component for the Input and InputContent components.
 * Provides styling such as the border and background.
 */
const InputContainer: React.FunctionComponent<Props> = (props: Props) => {
  const { disabled, invalid, readOnly, ...rest } = props;
  const classes = classnames('Input__container', {
    'Input__container--disabled': disabled,
    'Input__container--invalid': invalid,
    'Input__container--readonly': readOnly,
  });

  return (
    <Flex { ...rest }
        Component="label"
        className={ classes }
        direction="horizontal" />
  );
};

export default InputContainer;
